import { axios } from '@/services/axios';

const refireTrigger = async (selectedHistoryId) => {
    const res = await axios.post(
        `/trigger/historicalfire/${selectedHistoryId}`,
    );
    return res.data;
};

export default refireTrigger;
